import React, { createContext, useContext, useState } from "react";
import { translations } from "../locales/translations";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    return localStorage.getItem("hamarsathi_lang") || "en";
  });

  const setLanguage = (lang) => {
    setLanguageState(lang);
    localStorage.setItem("hamarsathi_lang", lang);
  };

  const t = (path) => {
    const keys = path.split(".");
    let current = translations[language];
    for (const key of keys) {
      if (current && current[key] !== undefined) {
        current = current[key];
      } else {
        // Fallback to English if key doesn't exist in Hindi
        let englishFallback = translations["en"];
        for (const fallbackKey of keys) {
          if (englishFallback && englishFallback[fallbackKey] !== undefined) {
            englishFallback = englishFallback[fallbackKey];
          } else {
            return path; // Return path if not found
          }
        }
        return englishFallback;
      }
    }
    return current;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
